import React from "react";
import { Box, Text } from "@ui-kit/components/index.es";

import I18n from "pages/_components/I18n";
import * as i18n from "util/i18n";

function SupportV3Content() {
    return (
        <Box column gap={24} w="100%" css={{ maxHeight: "50vh", minHeight: "50vh", overflowY: "auto" }}>
            <Text
                as="h2"
                variant="body"
                color="white"
                css={{ fontSize: 20, fontFamily: "inherit" }}
                componentProps={{ "data-testid": "support-title" }}>
                <I18n id="global.support" />
            </Text>
            <Box column gap={20}>
                <Text variant="body" color="white" component="p">
                    <I18n id="global.support.v3.intro" />
                </Text>

                <Text variant="body" color="white" component="p">
                    <I18n id="global.support.v3.whatsapp.label" /> <I18n id="global.support.v3.whatsapp.value" />
                </Text>

                <Text variant="body" color="white" component="p">
                    <I18n id="global.support.v3.email.label" />{" "}
                    <a
                        href={i18n.get("global.support.v3.email.href")}
                        style={{ color: "inherit", textDecoration: "underline" }}>
                        <I18n id="global.support.v3.email.value" />
                    </a>
                </Text>

                <Text variant="body" color="white" component="p">
                    <I18n id="global.support.v3.phone.label" />{" "}
                    <a
                        href={i18n.get("global.support.v3.phone.href")}
                        style={{ color: "inherit", textDecoration: "underline" }}>
                        <I18n id="global.support.v3.phone.value" />
                    </a>
                </Text>
            </Box>
        </Box>
    );
}

export default SupportV3Content;
